
/**
 * Tipo di visualizzazione dello YIELD: effettivo o pianificato
 */
export enum YIELD_TYPE {
	ACTUAL = "actual",
	PROJECTED = "projected"
}

/**
 * Tipo di aggregazione dei dati per i grafici
 */
export type BucketMode = 'day' | 'week' | 'month' | 'quarter'

